import React from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export function googleLoginRedirect(returnPath) {
  const redirect = encodeURIComponent(window.location.origin + returnPath);
  window.location.href = `https://auth.emergentagent.com/?redirect=${redirect}`;
}

export function hasGoogleSessionHash() {
  return (window.location.hash || '').includes('session_id=');
}

export async function consumeGoogleSession(context = 'auto') {
  const m = (window.location.hash || '').match(/session_id=([^&]+)/);
  if (!m) return null;
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  const res = await fetch(`${API}/api/auth/google/session`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id: m[1], context }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(typeof data?.detail === 'string' ? data.detail : 'google_auth_failed');
    err.detail = data?.detail;
    throw err;
  }
  return data;
}

export function GoogleIcon({ className = 'w-4 h-4' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47a5.57 5.57 0 0 1-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A11.99 11.99 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.27 14.29a7.19 7.19 0 0 1 0-4.58V6.62H1.29a12.04 12.04 0 0 0 0 10.76l3.98-3.09z" />
      <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.69 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
    </svg>
  );
}
